import React, { useEffect } from "react";
import i18n from "./translations";
import { I18nextProvider } from "react-i18next";
import { Routes, Route, useSearchParams } from "react-router-dom";
import { Provider } from "react-redux";
import routes from "./routes";
import "./assets/css/App.css";
import Header from "./_shared/Header/header";
import Footer from "./_shared/Footer/footer";
import store from "./redux/store";
import PageNotFound from "./_shared/pages/PageNotFound";

// import { useIdleTimer } from 'react-idle-timer'

function App() {
  const [params] = useSearchParams()
  // let hash = window.location.hash.split("ar")[1] || "";
  // const getQueryParams = (query = null) =>
  //   [...new URLSearchParams(query || hash || "").entries()].reduce(
  //     (a, [k, v]) => ((a[k] = v), a),
  //     {}
  //   );

  // useEffect(() => {
  //   if (hash && hash.length > 0) {
  //     let paramData = getQueryParams();
  //     localStorage.setItem("paramAttributes", JSON.stringify(paramData));
  //   }
  // }, []);

  useEffect(() => {
    if (params.size > 0) {
      window.localStorage.setItem(
        'paramAttributes',
        JSON.stringify(Object.fromEntries([...params]))
      )
    }
  }, [params])

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }
      return null;
    });
  // const onIdle = () => {
  //   // Close Modal Prompt
  //   // Do some idle action like log out your user
  //   window.location.reload();
  // }
  // const {isIdle, idleTimer} = useIdleTimer({ onIdle, timeout: 300000 });

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <div className="App">
          <Header />
          <div className="content">
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </I18nextProvider>
    </Provider>
  );
}

export default App;
